import * as Types from '../../../generated.types'

import { useMutation, UseMutationOptions } from '@tanstack/react-query'
import { fetchGql } from '@alice-financial/api'
export type AcceptOrderFormMutationVariables = Types.Exact<{
  acceptanceId: Types.Scalars['Int']
  acceptEsign?: Types.InputMaybe<Types.Scalars['Boolean']>
  signatureSrc?: Types.InputMaybe<Types.Scalars['String']>
  metadata?: Types.InputMaybe<Types.Scalars['JSON']>
}>

export type AcceptOrderFormMutation = {
  __typename?: 'Mutation'
  acceptAgreement?: {
    __typename?: 'AcceptAgreementPayload'
    acceptance?: { __typename?: 'Acceptance'; id: number } | null
  } | null
}

export const AcceptOrderFormDocument = `
    mutation AcceptOrderForm($acceptanceId: Int!, $acceptEsign: Boolean, $signatureSrc: String, $metadata: JSON) {
  acceptAgreement(
    input: {acceptanceId: $acceptanceId, acceptEsign: $acceptEsign, signatureSrc: $signatureSrc, metadata: $metadata}
  ) {
    acceptance {
      id
    }
  }
}
    `
export const useAcceptOrderFormMutation = <TError = Error, TContext = unknown>(
  options?: UseMutationOptions<AcceptOrderFormMutation, TError, AcceptOrderFormMutationVariables, TContext>
) =>
  useMutation<AcceptOrderFormMutation, TError, AcceptOrderFormMutationVariables, TContext>(
    ['AcceptOrderForm'],
    (variables?: AcceptOrderFormMutationVariables) =>
      fetchGql<AcceptOrderFormMutation, AcceptOrderFormMutationVariables>(
        AcceptOrderFormDocument,
        variables
      )(),
    options
  )
